import React, {  useEffect, useState,useRef,useContext  } from "react";



export default function Module3dsTrustpay(props) {
      
  
    const [loaded, setLoaded] = useState(false);

    const formRef_2 = useRef(null);
    const iframeRef = useRef(null); 
    
    useEffect(() => { 
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.name = 'hidden-iframe';
        iframe.onload = setLoaded(true)
        document.body.appendChild(iframe);

        if(props.redirectPreconditions){
            const form_data = new FormData();
            Object.entries(props.redirectPreconditions.parameters[0]).forEach(([key, value]) => {
                form_data.append(key, value);
            });

            const form = document.createElement('form');
            form.method = 'POST';
            form.action = props.redirectPreconditions.url;
            form.target = 'hidden-iframe'; // Set target to the iframe name

            // Append inputs from FormData to the form
            for (let [key, value] of form_data.entries()) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = value;
                form.appendChild(input);
            }

            document.body.appendChild(form);
            form.submit();
        }else{
            
            setLoaded(true)
        }
        
       


    },[]);


    useEffect(() => {  
        
        const form_data = new FormData();
        Object.entries(props.redirectParams).forEach(([key, value]) => {
            form_data.append(key, value);
        });

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = props.redirectUrl;

        for (let [key, value] of form_data.entries()) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = value;
            form.appendChild(input);
        }
        
        document.body.appendChild(form);
        form.submit();
        

    },[loaded]);


   

    

    return (
        <div className="all-container bg-light pianiAbbonamentoPage">
  
        </div>
    )
   


}